class TopValueOverlays extends PIXI.Container {
  constructor() {
    super();
    messageBus.subscribe(
      "spinner:GameConfigEvent",
      this.onGameConfigEvent.bind(this)
    );
    gameController.reelData = [];
    this.movedCoinValues = [];
    this.valueOverlays = [];
    this.mainContainer = undefined;
  }

  initialise() {
    const self = this;
    let index = 0;
    this.mainContainer = resourceManager.createObject(
      "container",
      `mainContainer`,
      this,
      {}
    );

    for (let reel = 0; reel < gameData.numReels; reel++) {
      for (let row = 0; row < gameData.numRows; row++) {
        const orginSymX = gameController.reelData[reel].position.x;
        const orginSymY =
          gameController.reelData[reel].position.y +
          gameController.reelData[reel]._symbolSpacing * row;
        const slotCell = reel * gameData.numRows + row;

        let parentContainer = resourceManager.createObject(
          "container",
          `parentContainer${slotCell}`,
          this,
          {
            x: orginSymX,
            y: orginSymY,
          }
        );

        let valueContainer = resourceManager.createObject(
          "container",
          `valueContainer`,
          parentContainer,
          {}
        );

        let dimValueContainer = resourceManager.createObject(
          "container",
          `dimValueContainer`,
          parentContainer,
          {}
        );

        let coinCashOverlay = resourceManager.createObject(
          "text",
          `coinCashOverlay`,
          valueContainer,
          {
            text: "",
            fontDefinition: "cashLinkCoinText",
            x: 3,
            y: 0,
            maxWidth: 120,
            anchor: 0.5,
          }
        );

        let miniOverlay = resourceManager.createObject(
          "sprite",
          `miniOverlay`,
          valueContainer,
          {
            anchor: 0.5,
            fileName: "potBonus/Mini_jackpot.png",
          }
        );

        let miniDimOverlay = resourceManager.createObject(
          "sprite",
          `miniDimOverlay`,
          dimValueContainer,
          {
            maxWidth: 120,
            anchor: 0.5,
            alpha: 0.5,
            fileName: "potBonus/Mini_jackpot.png",
          }
        );

        let minorOverlay = resourceManager.createObject(
          "sprite",
          `minorOverlay`,
          valueContainer,
          {
            anchor: 0.5,
            fileName: "potBonus/Minor_jackpot.png",
          }
        );

        let minorDimOverlay = resourceManager.createObject(
          "sprite",
          `minorDimOverlay`,
          dimValueContainer,
          {
            anchor: 0.5,
            alpha: 0.5,
            fileName: "potBonus/Minor_jackpot.png",
          }
        );

        let majorOverlay = resourceManager.createObject(
          "sprite",
          `majorOverlay`,
          valueContainer,
          {
            anchor: 0.5,
            fileName: "potBonus/Major_jackpot.png",
          }
        );

        let majorDimOverlay = resourceManager.createObject(
          "sprite",
          `majorDimOverlay`,
          dimValueContainer,
          {
            anchor: 0.5,
            alpha: 0.5,
            fileName: "potBonus/Major_jackpot.png",
          }
        );

        let megaOverlay = resourceManager.createObject(
          "sprite",
          `megaOverlay`,
          valueContainer,
          {
            anchor: 0.5,
            fileName: "potBonus/Mega_jackpot.png",
          }
        );

        let megaDimOverlay = resourceManager.createObject(
          "sprite",
          `megaDimOverlay`,
          dimValueContainer,
          {
            anchor: 0.5,
            alpha: 0.5,
            fileName: "potBonus/Mega_jackpot.png",
          }
        );

        miniOverlay.visible = false;
        majorOverlay.visible = false;
        megaOverlay.visible = false;
        minorOverlay.visible = false;
        miniDimOverlay.visible = false;
        majorDimOverlay.visible = false;
        megaDimOverlay.visible = false;
        minorDimOverlay.visible = false;

        let coinCashDimOverlay = resourceManager.createObject(
          "text",
          `coinCashDimOverlay${slotCell}`,
          dimValueContainer,
          {
            text: "",
            fontDefinition: "cashLinkCoinText",
            x: 3,
            y: 0,
            alpha: 0.5,
            maxWidth: 120,
            anchor: 0.5,
          }
        );

        coinCashOverlay.visible = false;
        coinCashDimOverlay.visible = false;
        this.valueOverlays.push({
          value: "",
          parentContainer: parentContainer,
          valueContainer: valueContainer,
          coinValue: coinCashOverlay,
          coinValueDim: coinCashDimOverlay,
          mini: miniOverlay,
          major: majorOverlay,
          mega: megaOverlay,
          minor: minorOverlay,
          miniDim: miniDimOverlay,
          majorDim: majorDimOverlay,
          megaDim: megaDimOverlay,
          minorDim: minorDimOverlay,
          reel: reel,
          row: row,
          originalPosition: { x: orginSymX, y: orginSymY },
        });
        index++;
      }
    }
    this.removeAllChildren();
  }

  removeAllChildren() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      this.removeChild(this.valueOverlays[i].parentContainer);
    }
  }

  addOrRemoveValueContainer(show, slotCell) {
    if (show) {
      this.addChild(this.valueOverlays[slotCell].parentContainer);
    } else {
      this.removeChild(this.valueOverlays[slotCell].parentContainer);
    }
  }

  setCoinValue(slotCell, coinDetails) {
    if (coinDetails.type === "Cash") {
      const value =
        PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
          coinDetails.amount / 100
        );
      this.valueOverlays[slotCell].coinValue.setText(value);
      this.valueOverlays[slotCell].coinValueDim.setText(value);
    }
  }

  getPotValue(slotCell, potType) {
    return resourceManager.get(
      `slotContainer:valueOverlays:valueContainer${slotCell}:valueContainer${slotCell}:${potType.toLowerCase()}Overlay${slotCell}`
    );
  }

  fadeInCashlinkValue(slotCell, cb, type, potName) {
    const overlay = this.valueOverlays[slotCell];
    if (!overlay) return;

    overlay.valueContainer.alpha = 0;

    if (type === "Cash") {
      this.showCoinDimValue(true, slotCell);
      this.showCoinValue(true, slotCell);
    } else if (type === "Pot") {
      this.showPotDimValue(true, slotCell, potName);
      this.showPotValue(true, slotCell, potName);
    }

    gsap.to(overlay.valueContainer, {
      duration: 0.2,
      delay: 0.1,
      alpha: 1,
      onComplete: cb,
    });
  }

  resetValues(slotCell) {
    this.valueOverlays[slotCell].coinValueDim.setText("");
    this.valueOverlays[slotCell].coinValue.setText("");
  }

  showCoinValue(show, slotCell) {
    this.addOrRemoveValueContainer(show, slotCell);
    this.valueOverlays[slotCell].coinValue.visible = show;
  }

  showPotValue(show, slotCell, potType) {
    this.addOrRemoveValueContainer(show, slotCell);
    let pot = potType.toLowerCase();
    this.valueOverlays[slotCell][pot].visible = show;
  }

  showPotDimValue(show, slotCell, potType) {
    this.valueOverlays[slotCell][`${potType.toLowerCase()}Dim`].visible = show;
  }

  getCoinValue(slotCell) {
    return this.valueOverlays[slotCell].coinValue;
  }

  getCoinContainer(slotCell) {
    return this.valueOverlays[slotCell].valueContainer;
  }

  showCoinDimValue(show, slotCell) {
    this.valueOverlays[slotCell].coinValueDim.visible = show;
  }

  setTotalCoinValue(slotCell, coinValue) {
    this.valueOverlays[slotCell].totalCash.setText(coinValue);
  }

  resetValuePostions() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      this.valueOverlays[i].valueContainer.x = 0;
      this.valueOverlays[i].valueContainer.y = 0;
      this.valueOverlays[i].valueContainer.visible = true;
      this.valueOverlays[i].valueContainer.scale.set(1);
    }
  }

  clearAllCoinAndPotValues() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      this.addOrRemoveValueContainer(false, i);
      this.valueOverlays[i].coinValue.visible = false;
      this.valueOverlays[i].coinValueDim.visible = false;
      this.resetValues(i);
    }
    this.hideAllPots();
  }

  hidePots(slotCell) {
    if (this.valueOverlays[slotCell][`mini`]) {
      this.valueOverlays[slotCell][`mini`].visible = false;
      this.valueOverlays[slotCell][`mega`].visible = false;
      this.valueOverlays[slotCell][`minor`].visible = false;
      this.valueOverlays[slotCell][`major`].visible = false;
    }
  }

  hideAllPots() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      if (this.valueOverlays[i][`mini`]) {
        this.valueOverlays[i][`mini`].visible = false;
        this.valueOverlays[i][`mega`].visible = false;
        this.valueOverlays[i][`minor`].visible = false;
        this.valueOverlays[i][`major`].visible = false;
      }
    }
  }

  onGameConfigEvent() {
    this.initialise();
  }
}

var topValueOverlaysDisplayCreator = function (json) {
  return new TopValueOverlays();
};

var topValueOverlaysDisplayInitialiser = function (json, buggy) {};

var topValueOverlaysDisplayFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "TopValueOverlays",
  topValueOverlaysDisplayCreator,
  topValueOverlaysDisplayInitialiser,
  topValueOverlaysDisplayFilesRequired
);
